import React, { useEffect } from "react";
import styled from "styled-components";
import HeroSection from "./HeroSection";
import Newest from "./Newest";
import PhysicalStores from "./PhysicalStores";
import Footer from "./Footer";
import LayoutContext from "./../../../contexts/LayoutContext";
import * as Library from "../../../utils/Library";
import { useState } from "react";
import EntitiesSection from "./Sections/EntitiesSection";
import { useNavigate } from "react-router-dom";
import { heroSection, shopByBrandSection, shopByStoreSection, newestSection, physicalStoresSection } from "../../../config/homepageConfig";

/* #region CSS */
const StyledPage = styled.div`
    &.main,
    &.main * {
        box-sizing: border-box;
    }
    &.main {
        height: 100%;
        width: 100%;
        overflow: scroll;
    }
    .main-home-container {
        display: flex;
        flex-direction: column;
        gap: 0px;
    }
`;
/* #endregion CSS */

export default function Index() {
    /* #region VARS */
    const navigate = useNavigate();

    const [storeBrandData, setStoreBrandData] = useState([]);
    const [isLoadingStoreBrand, setIsLoadingStoreBrand] = useState(true);
    const [retailBrandData, setRetailBrandData] = useState([]);
    const [isLoadingRetailBrand, setIsLoadingRetailBrand] = useState(true);

    const {
        setShowFooter,
        setHomeLogo,
        setFeedLogo,
        setShowRightUserLocationPanel,
        setShowRightCheckoutPanel,
        setShowRightMyOrdersPanel,
        setShowRightSettingsPanel,
        setShowRightMyOrdersDetailsPanel,
        setShowYourAccountPannel,
        setShowStorePanel,
        setShowPaymentMethodPanel,
        isMobile,
        setShowSuggestPopup,
        setShowSuggestStorePopup,
        setShowRightAiPanel,
        setIsSearchByAi
    } = React.useContext(LayoutContext);
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        setShowFooter(false);
        setHomeLogo(true);
        setFeedLogo(false);
        getShopByBrand();
        getShopByStore();
        resetAllSidePanels();
    }, []);
    /* #endregion */

    /* #region FUNCTIONS */
    const getShopByBrand = async () => {
        try {
            const payload = {
                page: 1,
                limit: 100
            };
            const res = await Library.makePostRequest("getHomeBrands", payload, undefined, setIsLoadingRetailBrand);
            const { data } = res;
            if (res?.status === 200) {
                const transformedData = data?.data?.data?.map(item => ({
                    _id: item?._id,
                    name: item?.name,
                    backgroundLogo: item?.BOtagHomeURL,
                    entityLogo: item?.mainLogoURL,
                    isDisabled: item?.status === "Active" ? false : true
                }));
                setRetailBrandData(transformedData);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getShopByStore = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10
            };
            const res = await Library.makePostRequest("getHomeRetailBrands", payload, false, setIsLoadingStoreBrand);
            const { data } = res;

            if (res?.status === 200) {
                const transformedData = data?.data?.data?.map(item => ({
                    _id: item?._id,
                    backgroundLogo: item?.randomStoreImage,
                    entityLogo: item?.mainLogoURL,
                    isDisabled: item?.status === "Active" ? false : true
                }));
                setStoreBrandData(transformedData);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const resetAllSidePanels = () => {
        setShowRightUserLocationPanel(false);
        setShowRightCheckoutPanel(false);
        setShowRightMyOrdersPanel(false);
        setShowRightSettingsPanel(false);
        setShowYourAccountPannel(false);
        setShowStorePanel(false);
        setShowPaymentMethodPanel(false);
        setShowRightMyOrdersDetailsPanel({
            orderID: null,
            isOpen: false
        });
        setIsSearchByAi(false);
    };
    const navigateToBrands = item => {
        const imageFilter = "Posts";
        const brands = [{ _id: item?._id, name: item?.name }];
        navigate("/search", {
            state: { imageFilter, brands }
        });
    };
    const navigateToRetailStore = item => {
        navigate(`/retailerStores/${item?._id}`);
    };
    /* #endregion FUNCTIONS*/

    return (
        <StyledPage className="main">
            <div className="main-home-container">
                <HeroSection
                    title={heroSection?.title}
                    description={heroSection?.description}
                    buttonTitle={heroSection?.buttonTitle}
                    buttonOnClick={() => setShowRightAiPanel(true)}
                />

                <EntitiesSection
                    title={shopByBrandSection?.title}
                    description={shopByBrandSection?.description}
                    entities={retailBrandData}
                    showDescriptionInMobile={isMobile}
                    buttonTitle={shopByBrandSection?.buttonTitle}
                    buttonOnClick={() => setShowSuggestPopup(true)}
                    onEntityClick={navigateToBrands}
                    isLoading={isLoadingRetailBrand}
                />

                <Newest title={newestSection?.title} description={newestSection?.description} buttonTitle={newestSection?.buttonTitle} />

                <EntitiesSection
                    title={shopByStoreSection?.title}
                    description={shopByStoreSection?.description}
                    entities={storeBrandData}
                    showDescriptionInMobile={isMobile}
                    buttonTitle={shopByStoreSection?.buttonTitle}
                    buttonOnClick={() => setShowSuggestStorePopup(true)}
                    onEntityClick={navigateToRetailStore}
                    isLoading={isLoadingStoreBrand}
                />

                <PhysicalStores
                    title={physicalStoresSection?.title}
                    description={physicalStoresSection?.description}
                    buttonTitle={physicalStoresSection?.buttonTitle}
                />

                <Footer />
            </div>
        </StyledPage>
    );
}
